<template lang="pug">
	
	.video-element
		.video-wrapper

			.video-visual
				.video-overlay-background
				img(:src="poster").poster

			a(:href="href" target='blank').video-content(@mouseenter="start" @mouseleave="start")
				.video-play-icon
					img(src="assets/images/play-full-icon.png")
				.video-title
					p.catch Écouter
					p.title
						span(v-for="word in splitTitle") {{word}}&nbsp;

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Globals from '~utils/Globals.js'
	
  @Component({
		name: 'VideoElement',
		components: {  },
		props: ["width","height","poster","video","responsive","title","href","onEnter","onLeave","item"],
		data: function () {
			return {
				splitTitle: this.title ? this.title.split(' ') : []
			}
		}
	})

	class VideoElement extends Vue {

		mounted () {
			this.init()
		}

		init () {

			this._dom()
			this._setPadding()
			this.resize = this._resize.bind(this)

			this.tl = new TimelineMax({paused: true})

			this.tl
					.fromTo([this.$posterImg],.3,{scale:1.1},{scale:1.2},0)
					.fromTo(this.$videoVisual,.3,{scale:1},{scale:.95},0)
					.staggerTo(this.$titleLetter,.4,{y:0,opacity:1,ease: Power3.easeInOut},.03,0)

			this._on()
		
		}

		_on () {
			this.$events.on('app.loaded', this.init);
			this.$events.on('app.resize', this._resize);
		}


		_dom () {
			this.$wrapVideo = this.$el.querySelector('.video-wrapper')
			this.$posterImg = this.$el.querySelector('.poster')
			this.$videoVisual = this.$el.querySelector('.video-visual')
			this.$titleLetter = this.$el.querySelectorAll('.title span')
			this.$title = this.$el.querySelector('.title')
			this.$layer = this.$el.querySelector('.video-overlay-background')
		}

		_setPadding () {

			const w = this.width
			const h = this.height

			this.$wrapVideo.style.paddingBottom = `${(h/w) * 100}%`
			
			if(!this.responsive) {
				this.$el.style.width = `${Globals.responsiveWidth(w)}px`
			}
			
		}

		_resize () {
			this._setPadding()
		}

		start (e) {
			if(e.type === "mouseenter") {
				this.tl.play()
				this.onEnter && this.onEnter(this.item)
			} else if(e.type === "mouseleave") {
				this.tl.reverse()
				this.onLeave && this.onLeave(this.item)
			}
		}

	}

	export default VideoElement

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.video-element
		position relative
		width 100%
		overflow hidden
		will-change transform
		z-index 40
		
		.video-wrapper
			width 100%
			position relative
			overflow hidden

			.video-visual
				position absolute
				top 0
				left 0
				width 100%
				height 100%
				z-index 40
				overflow hidden

				.video-overlay-background
					background-color rgb(#000)
					opacity .7
					position absolute
					z-index 50
					top -2px
					left -2px
					bottom -2px
					right -2px

				img
					width 100%
					height 100%
					object-fit cover
			
			.video-content
				position absolute
				top 0
				left 0
				height 100%
				width 100%
				z-index 60
				display flex
				justify-content center
				align-items center
				flex-direction column
				cursor pointer
				text-decoration none

				.video-play-icon
					position relative
					z-index 60

					img
						display inline-block
						position relative
						z-index 50

				.video-title
					position relative
					z-index 70
					margin-top 4px

					.title
						margin-top 6px

					p
						color #fff
						text-align center
						font-family $FONT_SECONDARY
						letter-spacing .15em
						font-size em(15px)
						text-transform uppercase

						span
							display inline-block
							transform translateY(5px)
							opacity 0

						&.catch
							font-weight 300
</style>


// WEBPACK FOOTER //
// video-element.vue?51ef8083